export class TournamentsFiltersRequest {
  start_date_min_timestamp: number | null = null;
  start_date_max_timestamp: number | null = null;
}
